/**
 * Confetti for the first "Your plan is ready": the burst the older D2C payment-success page used, laid
 * over the screen, and it stops on its own after a few seconds.
 */
import { useEffect, useState } from 'react';

const CONFETTI_MS = 5000;

/** True for a few seconds each time `active` turns true. */
export function useConfettiBurst(active: boolean): boolean {
  const [isVisible, setIsVisible] = useState(active);

  useEffect(() => {
    if (!active) return;
    setIsVisible(true);
    const timer = setTimeout(() => setIsVisible(false), CONFETTI_MS);
    return () => clearTimeout(timer);
  }, [active]);

  return isVisible;
}
